import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { FilteredEventInfos, MatchListStoreModel } from '../match-list/utils/match-list-models';
import { ADVANTAGE_SYMBOL } from '../match-list/utils/match-list.constants';
import { getFilteredEventInfosSelector } from '@om-fe/core/components/event-slider/event-slider.selectors';
import { EventSliderStoreMainModel } from '@om-fe/core/components/event-slider/event-slider.store';
import getSlice from '@om-fe/core/utils/get-slice';
import { BemMethod, createBem } from '@om-fe/utils';

export interface ScoreElementPublicProps {
    readonly sliceKey: string;
    readonly scoreElementId: string;
    readonly homeParticipantId?: string;
    readonly moreThanOne?: boolean;
    readonly isEventSlider?: boolean;
}

interface ScoreElementStoreProps {
    readonly scoreElement?: FilteredEventInfos;
}

interface ScoreObj {
    readonly home: string | number;
    readonly away: string | number;
}

export type ContextTextProps = ScoreElementPublicProps & ScoreElementStoreProps;

const bem: BemMethod = createBem({
    name: 'Score',
});

class ScoreElementComponent extends React.PureComponent<ContextTextProps> {

    pickCorrectParticipant(element: FilteredEventInfos) {
        const { paramFloat1, paramFloat2, paramParticipantId1 } = element;
        const { homeParticipantId, moreThanOne } = this.props;

        let scoreObj: ScoreObj = {
            home: paramFloat2,
            away: paramFloat1,
        };

        if (homeParticipantId === paramParticipantId1) {
            scoreObj = {
                home: paramFloat1,
                away: paramFloat2,
            };
        }

        return (
            <>
                <span
                    className={bem({ element: 'Part', modifiers: 'Home' })}
                >
                    {moreThanOne && scoreObj.home === 50 ? ADVANTAGE_SYMBOL : scoreObj.home}
                </span>
                <span
                    className={bem({ element: 'Part', modifiers: 'Away' })}
                >
                    {moreThanOne && scoreObj.away === 50 ? ADVANTAGE_SYMBOL : scoreObj.away}
                </span>
            </>
        );

    }

    render() {
        const { scoreElement } = this.props;

        if (!scoreElement) {
            return null;
        }

        return (
            <span
                className={bem({
                    element: 'PartGroup',
                    modifiers: [`${scoreElement.eventPartId}`, `StatusId-${scoreElement.statusId}`],
                })}
            >
              {this.pickCorrectParticipant(scoreElement)}
            </span>
        );
    }
}

const ScoreElement: React.ComponentType<ScoreElementPublicProps> = connect<ScoreElementStoreProps, undefined, ScoreElementPublicProps>(
    () => {
        const eventSliderFilteredEventInfos = getFilteredEventInfosSelector();

        return (state: AppState, props: ScoreElementPublicProps): ScoreElementStoreProps => {
            const slice: EventSliderStoreMainModel | MatchListStoreModel | undefined = getSlice<EventSliderStoreMainModel | MatchListStoreModel>(state, props.sliceKey);
            const { isEventSlider, scoreElementId } = props;

            if (!slice) {
                return {};
            }

            const scoreElement: FilteredEventInfos | undefined = isEventSlider ?
                eventSliderFilteredEventInfos(slice as EventSliderStoreMainModel)[scoreElementId] : (
                    (slice as MatchListStoreModel).filteredEventInfos[scoreElementId]
                );

            return {
                scoreElement,
            };
        };
    },
)(ScoreElementComponent);

export default ScoreElement;
